import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { toSegments } from "../../utils/analyticsLabels";
import ChartFrame from "../charts/ChartFrame";
import ResponsiveChart from "../charts/ResponsiveChart";
import StackedBar, { STACKED_BAR_HEIGHT } from "../charts/StackedBar";
import { formatShare } from "../charts/format";

// Um breakdown do contrato ({total, values, unattributed}) numa barra empilhada, com a legenda (que
// diz o valor e a percentagem de cada chave) e a tabela.
const BreakdownChart = ({ title, note, lead, info, actions, breakdown, dimension, downloadName }) => {
  const { translate, language } = useLanguage();
  const segments = toSegments(breakdown, dimension, translate);
  const total = segments.reduce((sum, segment) => sum + segment.value, 0);
  const share = (value) => formatShare(value, total, language);
  const table = {
    columns: [
      { key: "label", label: translate("analyticsCategory") },
      { key: "value", label: translate("analyticsCount"), numeric: true, format: share },
    ],
    rows: segments,
  };
  return (
    <ChartFrame
      title={title}
      note={note}
      lead={lead}
      info={info}
      actions={actions}
      table={table}
      downloadName={downloadName}
      empty={total === 0}
      legend={segments.map((segment) => ({ key: segment.key, color: segment.color, label: `${segment.label}: ${share(segment.value)}` }))}
    >
      <ResponsiveChart height={STACKED_BAR_HEIGHT}>
        {(width) => <StackedBar segments={segments} width={width} label={title} formatValue={(value) => share(value)} />}
      </ResponsiveChart>
    </ChartFrame>
  );
};

export default BreakdownChart;
